if($('footer#footer').length){
    $('#footer#footer').before($('footer#footer .heurekaRating'))
    $('footer#footer').before($('footer#footer .custom-footer__newsletter'))
    $('footer#footer').before($('footer#footer .customInstagram'))
   
    $(".instagram-widget>a").each(function(){
        $(".instagramFeed").append('<div class="igfeed"><a href="'+$(this).attr("href")+'" target="_blank" style="background-image: url('+$(this).find("img").attr("data-src")+')"></a></div>')
    })
    if($('footer#footer .contact-box').length){
         $('footer#footer .contact-box').append('<ul class="socialList"></ul>')
         $('.socialList').append($('footer#footer .contact-box>ul span.instagram').closest('li'))
         $('.socialList').append($('footer#footer .contact-box>ul span.facebook').closest('li'))
     }
    $(document).on('click', '.custom-footer>div h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    })
}

$(document).ready(function() {
    var storedData = sessionStorage.getItem('ratingData');
    if (storedData) {
        $('.heurekaTopLogo').after(storedData);
    } else {
        $.ajax({
            url: '/hodnoceni-obchodu/',
            type: 'GET',
            success: function(response) {
                var content = $(response);
                var rateAverageInner = parseFloat(content.find('.rate-average-inner .rate-average').html().trim().replace(',', '.'));
                var rateStarWrapStar = content.find('.rate-star-wrap .stars').html();
                var rateStarWrapStarsLabel = content.find('.rate-star-wrap .stars-label').html();
                var percentilRating = Math.floor(100*parseFloat(rateAverageInner)/5)
                var ratingsFinal = content.find('.votes-wrap').html();

                var finalHtml = '<div class="bottom">'
                finalHtml += '<div class="ratingStars"><span class="stars">'+rateStarWrapStar+'</span></div>'
                finalHtml += '<span class="ratingText"><span class="number">'+percentilRating+'</span>% zákazníků by doporučilo fitVitaminy svým známým</span>'
                finalHtml += '<div class="text-center"><a href="/hodnoceni-obchodu/">'+rateStarWrapStarsLabel.split('(')[0].trim()+'</a></div>'
                finlRatings = '<div class="votes-wrap">'+ratingsFinal+'</div>'
                $('.heurekaTopLogo').after(finalHtml+finlRatings)

                sessionStorage.setItem('ratingData', finalHtml+finlRatings);
            },
            error: function(xhr, status, error) {
                console.error("Error fetching rating data:", status, error);
            }
        });
    }
});